import { createApp } from 'vue'
import App from './App.vue'
import './assets/styles/index.css'

// Vue.config.productionTip = false;

createApp(App).mount('#app')
